module.exports = __webpack_public_path__ + "img/home-emergency.6b641b19.png";